<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Manual CheckOut
      </h1>
      <br>
      <p class="subheader-style">
        Fill the below details to complete <br> check-out.
      </p>
      <v-card
        elevation="0"
        color="#E2E2E2"
      >
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-card-title>
            <p class="process-header">
              CheckOut OffSite
            </p>
          </v-card-title>
          <v-card-text>
            <v-textarea
              v-model="manualCheckoutReason"
              outlined
              light
              class="field-text-style"
              :counter="100"
              counter-value-color="red"
              :rules="[v => (v && v.length < 100) || 'Reason must be 100 characters or less']"
              filled
              hint="Reason for requesting a manual check-out."
              persistent-hint
              color="#000000"
              label="Reason*"
              dense
            />
            <v-datetime-picker
              v-model="checkOutTime"
              date-format="yyyy-MM-dd"
              label="Actual Check-out Time*"
              time-format="HH:mm:ss"
              :dialog-width="300"
              :text-field-props="{
                light: light,
                outlined: outlined,
                filled: filled,
                dense: dense,
                hint: 'Please specify the time you actually checked out of the site.',
                persistentHint: true,
                suffix: userTimeZone,
                class: 'field-text-style',
                rules: [v => !!v || 'Check-out Time is required']
              }"
              :date-picker-props="{
                headerColor: 'black',
                light: true,
                min: minDate,
              }"
              :time-picker-props="{
                headerColor: 'black',
                light: true,
                min: minTime,
                max: maxTime,
              }"
            >
              <template #dateIcon>
                <v-icon
                  large
                  color="white"
                >
                  mdi-calendar
                </v-icon>
              </template>
              <template #timeIcon>
                <v-icon
                  color="white"
                  large
                >
                  mdi-alarm
                </v-icon>
              </template>
            </v-datetime-picker>
          </v-card-text>
        </v-form>
      </v-card>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <v-btn
        color="#37474F"
        class="mt-5 btn-style"
        elevation="0"
        @click="confirm()"
      >
        Check-out
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
      <centre-spinner :loading="loading" />
      <overlay-alert
        :show-progress="showProgress"
        :process-alert="processAlert"
      />
    </div>
  </v-dialog>
</template>

<script>
import moment from 'moment-timezone';
import Constants from 'src/constants';
import OverlayAlert from 'src/views/components/OverlayAlert';
import spinner from 'src/views/components/SpinnerCentre';
export default {
  name: 'ManualCheckOutOffSite',
  components: {
    'overlay-alert': OverlayAlert,
    'centre-spinner': spinner,
  },
  data: () => ({
    showModal: true,
    loading: false,
    light: true,
    filled: true,
    outlined: true,
    dense: true,
    manualCheckoutReason: '',
    checkOutTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    valid: false,
    showProgress: false,
    processAlert: '',
    minDate: moment().format('YYYY-MM-DD'),
    maxTime: moment().format('HH:mm:ss'),
  }),
  computed: {
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    userTimeZone () {
      var Zone = moment.tz.guess();
      var timezone = moment.tz(Zone).zoneAbbr();
      return timezone;
    },
    minTime () {
      return moment(this.activeCheckInDetails.checkin_time).format('HH:mm:ss');
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
    checkOutTime (newValue) {
      if (newValue === null) {
        this.checkOutTime = moment().format('YYYY-MM-DD HH:mm:ss');
      }
    },
  },
  async mounted () {
    await this.fetchActiveCheckInDetails();
  },
  methods: {
    async fetchActiveCheckInDetails () {
      this.loading = true;
      await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails');
      this.loading = false;
    },
    confirm () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      if (this.checkOutTime === null || this.checkOutTime === '') {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please enter the check-out time.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      const checkOutTime = moment(this.checkOutTime, 'YYYY-MM-DD HH:mm:ss');
      const minTime = moment(this.minTime, 'HH:mm:ss');
      const currentTime = moment();

      if (!checkOutTime.isBetween(minTime, currentTime)) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please enter correct check-out time.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      setTimeout(() => {
        this.checkoutConfirmed();
      }, 1000);
    },
    async checkoutConfirmed () {
      this.loading = true;
      await this.$store.dispatch('swiftuser/saveManualCheckoutDetails', {
        reason: this.manualCheckoutReason,
        checkOutTime: this.checkOutTime,
      });
      await this.$store.dispatch('swiftuser/saveCheckoutType', 'manual');
      this.$emit('manual-offsite-confirmed');
      this.loading = false;
    },
  },
};
</script>
